// extracted by mini-css-extract-plugin
export var contentBody = "_7e-9";
export var headerImage = "_7e-2";
export var imageButton = "_7e-7";
export var imageButtonIcon = "_7e-8";
export var imageHeader = "_7e-4";
export var imageHeaderText = "_7e-5";
export var imageOverlay = "_7e-3";
export var imageTitle = "_7e-6";
export var imageWrapper = "_7e-1";
export var taskList = "_7e-a";
export var widget = "_7e-0";